<template>
  <div class="app-main-content">
    <div class="main-content" style="overflow: auto;">
      <div v-show="!isPreview" style="width: fit-content">
        <div v-if="addedElements && addedElements.length > 0" :class="'section' + (readonly ? ' not-click' : '')">
          <span class="title" style="width: 100%;">
            <span>{{ $t('SystemMaintenance.SystemAddedItem') }}</span>（{{ $t('SystemMaintenance.DragTheBlockUse') }}）
          </span>
          <div>
            <div v-for="element in addedElements" :ref="'added' + element.pagePartElement.elementName" :key="element.pagePartElement.elementName" style="width: fit-content;display: inline-block;line-height: 30px;margin: 0 15px;">
              <span style="vertical-align: middle;">{{ element.sysLabel }}</span>
              <span class="element-column-content sort-char" style="line-height: unset;" @mousedown="onAddedMousedown($event, element)">≡</span>
            </div>
          </div>
        </div>
        <div style="display: flex">
          <div v-for="block in upBlocks" :ref="block.pagePart.pagePartName" :key="block.pagePart.pagePartName" class="section" style="width: 371px;margin-right: 5px;">
            <el-form label-width="125px" label-position="right">
              <span :class="'title' + (readonly ? ' not-click' : '')" style="width: 100%;">
                {{ block.customLabel || block.sysLabel }}
                <i class="el-icon-edit" style="margin-left: 5px;" @click="onEditBlockLabel(block)" />
                <!-- <span class="sort-char" style="float: right;" @mousedown="onMousedown($event, block)">≡</span> -->
              </span>
              <el-form-item label=" ">
                <span class="element-column-text" :title="$t('SeaExport.Display')">{{ $t('SeaExport.Display') }}</span>
                <span class="element-column-text" :title="$t('SeaExport.Required')">{{ $t('SeaExport.Required') }}</span>
                <span class="element-column-text" :title="$t('SystemMaintenance.Alias')" style="width: 80px;">{{ $t('SystemMaintenance.Alias') }}</span>
                <span class="element-column-text" :title="$t('Tool.Setting')">{{ $t('Tool.Setting') }}</span>
                <span class="element-column-text" :title="$t('SystemMaintenance.Sort')">{{ $t('SystemMaintenance.Sort') }}</span>
              </el-form-item>
              <el-form-item v-for="element in block.uiCustomElementList" :ref="element.pagePartElement.elementName" :key="element.pagePartElement.elementName">
                <span slot="label" :class="element.isRequire ? 'blue' : ''">{{ element.sysLabel }}</span>
                <el-checkbox
                  v-model="element.isDisplay"
                  :disabled="readonly || !element.pagePartElement.displayCanCustom || (!!element.hqUICustomElement && element.hqUICustomElement.isRequire) || checkHqSetDisable(element)"
                  class="element-column-content"
                  @change="onDisplayChange(block, element)"
                />
                <el-checkbox
                  v-model="element.isRequire"
                  :disabled="readonly || !element.pagePartElement.requireCanCustom || !element.isDisplay || (!!element.hqUICustomElement && element.hqUICustomElement.isRequire) || checkHqSetDisable(element)"
                  class="element-column-content"
                />
                <span class="element-column-text" :title="element.customLabel" style="width: 80px;pointer-events: auto;">{{ element.customLabel }}</span>
                <span v-if="readonly" class="element-column-content">
                  <div v-if="(element.languageList && element.languageList.length > 0) || element.multipleRole" class="look-blue" @click="onEditElementLabel(element)" />
                  <div v-else class="look-gray" />
                </span>
                <span v-if="!readonly" :class="'element-column-content' + (element.isDisplay ? '' : ' el-icon-edit-disabled')">
                  <i class="el-icon-edit" @click="onEditElementLabel(element)" />
                </span>
                <span :class="'element-column-content sort-char' + (readonly ? ' not-click' : '')" style="line-height: unset;" @mousedown="onMousedown($event, block, element)">≡</span>
              </el-form-item>
            </el-form>
          </div>
        </div>
        <div v-if="downBlock" class="section" style="width: 371px">
          <el-form label-width="125px" label-position="right">
            <span :class="'title' + (readonly ? ' not-click' : '')" style="width: 100%;">
              {{ downBlock.customLabel || downBlock.sysLabel }}
              <i class="el-icon-edit" style="margin-left: 5px;" @click="onEditBlockLabel(downBlock)" />
            </span>
            <el-form-item label=" ">
              <span class="element-column-text" :title="$t('SeaExport.Display')">{{ $t('SeaExport.Display') }}</span>
              <span class="element-column-text" :title="$t('SeaExport.Required')">{{ $t('SeaExport.Required') }}</span>
              <span class="element-column-text" :title="$t('SystemMaintenance.Alias')" style="width: 80px;">{{ $t('SystemMaintenance.Alias') }}</span>
              <span class="element-column-text" :title="$t('Tool.Setting')">{{ $t('Tool.Setting') }}</span>
            </el-form-item>
            <el-form-item v-for="element in downBlock.uiCustomElementList" :ref="element.pagePartElement.elementName" :key="element.pagePartElement.elementName">
              <span slot="label" :class="element.isRequire ? 'blue' : ''">{{ element.sysLabel }}</span>
              <el-checkbox
                v-model="element.isDisplay"
                :disabled="readonly || !element.pagePartElement.displayCanCustom || (!!element.hqUICustomElement && element.hqUICustomElement.isRequire) || checkHqSetDisable(element)"
                class="element-column-content"
                @change="onDisplayChange(downBlock, element)"
              />
              <el-checkbox
                v-model="element.isRequire"
                :disabled="readonly || !element.pagePartElement.requireCanCustom || !element.isDisplay || (!!element.hqUICustomElement && element.hqUICustomElement.isRequire) || checkHqSetDisable(element)"
                class="element-column-content"
              />
              <span class="element-column-text" :title="element.customLabel" style="width: 80px;pointer-events: auto;">{{ element.customLabel }}</span>
              <span v-if="readonly" class="element-column-content">
                <div v-if="(element.languageList && element.languageList.length > 0) || element.multipleRole" class="look-blue" @click="onEditElementLabel(element)" />
                <div v-else class="look-gray" />
              </span>
              <span v-if="!readonly" :class="'element-column-content' + (element.isDisplay ? '' : ' el-icon-edit-disabled')">
                <i class="el-icon-edit" @click="onEditElementLabel(element)" />
              </span>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <!-- 以下复制了一份页面内容，用于拖拽 -->
      <template>
        <div v-if="addedElements && addedElements.length > 0" class="section" style="height: 0;overflow: hidden;padding: 0;margin-bottom: 0;">
          <span class="title" style="width: 100%;">
            <span>{{ $t('SystemMaintenance.SystemAddedItem') }}</span>（{{ $t('SystemMaintenance.DragTheBlockUse') }}）
          </span>
          <div>
            <div v-for="element in addedElements" :ref="'addDrag' + element.pagePartElement.elementName" :key="element.pagePartElement.elementName" style="width: fit-content;display: inline-block;line-height: 30px;margin: 0 15px;">
              <span style="vertical-align: middle;">{{ element.sysLabel }}</span>
              <span class="element-column-content sort-char" style="line-height: unset;">≡</span>
            </div>
          </div>
        </div>
        <div v-for="block in upBlocks" :ref="'drag' + block.pagePart.pagePartName" :key="block.pagePart.pagePartName" class="section" style="width: 371px;height: 0;overflow: hidden;padding: 0;margin-bottom: 0;">
          <el-form label-width="125px" label-position="right">
            <span class="title" style="width: 100%;">
              {{ block.customLabel || block.sysLabel }}
              <i class="el-icon-edit" style="margin-left: 5px;" />
              <span class="sort-char" style="float: right;">≡</span>
            </span>
            <el-form-item label=" ">
              <span class="element-column-text" :title="$t('SeaExport.Display')">{{ $t('SeaExport.Display') }}</span>
              <span class="element-column-text" :title="$t('SeaExport.Required')">{{ $t('SeaExport.Required') }}</span>
              <span class="element-column-text" :title="$t('SystemMaintenance.Alias')" style="width: 80px;">{{ $t('SystemMaintenance.Alias') }}</span>
              <span class="element-column-text" :title="$t('Tool.Setting')">{{ $t('Tool.Setting') }}</span>
              <!-- <span class="element-column-text" :title="$t('SystemMaintenance.Sort')">{{ $t('SystemMaintenance.Sort') }}</span> -->
            </el-form-item>
            <el-form-item v-for="element in block.uiCustomElementList" :ref="'drag' + element.pagePartElement.elementName" :key="element.pagePartElement.elementName" style="background-color: #f0f3f8;">
              <span slot="label" :class="element.isRequire ? 'blue' : ''">{{ element.sysLabel }}</span>
              <el-checkbox v-model="element.isDisplay" class="element-column-content" />
              <el-checkbox v-model="element.isRequire" class="element-column-content" />
              <span class="element-column-text" :title="element.customLabel" style="width: 80px;">{{ element.customLabel }}</span>
              <span class="element-column-content"><i class="el-icon-edit" /></span>
              <span class="element-column-content sort-char" style="line-height: unset;">≡</span>
            </el-form-item>
          </el-form>
        </div>
      </template>
      <!-- 预览 -->
      <tab-customs-info-UICustom v-if="isPreview" :context="bookingWorkspaceContext" action="look" :preview-config="previewConfig" />
    </div>
    <!-- 块设置弹窗 -->
    <block-set-dialog :visible.sync="blockSetDialog.visible" :block="blockSetDialog.block" />
    <!-- 元素设置弹窗 -->
    <element-set-dialog :visible.sync="elementSetDialog.visible" :element="elementSetDialog.element" :branch-id="branchId" :is-edit="isEdit" />
  </div>
</template>

<script>
import { DocumentManage } from '@/utils/commonUtil'
import { BookingWorkspaceContext } from '@/views/cargo/v0/SeaExport/components/booking/bookingWorkspaceContext'
import tabCustomsInfoUICustom from '@/components/Cargo/Job/booking/tabs/tabCustomsInfoUICustom'
import BlockSetDialog from '@/views/cargo/v0/SystemMaintenance/components/pageUICustom/BlockSetDialog'
import ElementSetDialog from '@/views/cargo/v0/SystemMaintenance/components/pageUICustom/ElementSetDialog'

export default {
  name: 'CustomsInfo',
  components: { tabCustomsInfoUICustom, BlockSetDialog, ElementSetDialog },
  props: {
    branchId: { type: Number, required: true },
    isEdit: { type: Boolean, required: true },
    blocks: { type: Array, required: true },
    addedElements: { type: Array, required: true },
    isPreview: { type: Boolean, required: true },
    previewConfig: { type: Object, default: null }
  },
  data() {
    return {
      bookingWorkspaceContext: new BookingWorkspaceContext(),
      blockWidth: 371,
      dragBlock: null,
      dragElement: null,
      dragEnabled: false,
      dragDiv: null,
      dragOffsetX: 0,
      dragOffsetY: 0,
      doc: new DocumentManage(),
      blockSetDialog: {
        visible: false,
        block: {}
      },
      elementSetDialog: {
        visible: false,
        element: {}
      }
    }
  },
  computed: {
    readonly() {
      return !this.isEdit
    },
    upBlocks() {
      return this.blocks.filter(p => p.pagePartPosition === 1)
    },
    downBlock() {
      return this.blocks.find(p => p.pagePartPosition === 2)
    },
    elementRelateBlockPropName() {
      return 'uiCustomElementBlockUuid'
    }
  },
  mounted() {
    this.doc.set('dragging', e => {
      if (!this.dragEnabled) {
        return
      }
      this.dragging(e)
    })
    this.doc.set('endDrag', e => {
      if (this.dragEnabled) {
        this.dragEnabled = false
        if (this.dragBlock) {
          this.handleDragSort(e.pageX, e.pageY)
        } else {
          this.handleAddedDragSort(e.pageX, e.pageY)
        }
        if (this.dragDiv) {
          if (!this.dragElement) {
            this.dragDiv.style.height = '0'
            this.dragDiv.style.overflow = 'hidden'
            this.dragDiv.style.padding = '0'
          }
          this.dragDiv.style.position = ''
          this.dragDiv.style.zIndex = ''
          this.dragDiv.style.left = ''
          this.dragDiv.style.top = ''
          this.dragDiv = null
        }
        this.dragBlock = null
        this.dragElement = null
        this.dragOffsetX = 0
        this.dragOffsetY = 0
      }
    })
    document.addEventListener('mousemove', this.doc.get('dragging'), false)
    document.addEventListener('mouseup', this.doc.get('endDrag'), false)
    document.addEventListener('mouseleave', this.doc.get('endDrag'), false)
  },
  beforeDestroy() {
    document.removeEventListener('mousemove', this.doc.get('dragging'), false)
    document.removeEventListener('mouseup', this.doc.get('endDrag'), false)
    document.removeEventListener('mouseleave', this.doc.get('endDrag'), false)
    this.doc.destory()
  },
  methods: {
    checkHqSetDisable(element) {
      return element.useHqSet && !!element.hqUICustomElement && !element.hqUICustomElement.isDisplay
    },
    onEditBlockLabel(block) {
      this.blockSetDialog.block = block
      this.blockSetDialog.visible = true
    },
    onEditElementLabel(element) {
      this.elementSetDialog.element = element
      this.elementSetDialog.visible = true
    },
    onDisplayChange(block, element) {
      if (element.isDisplay) {
        if (element.pagePartElement.masterIncluded) {
          element.masterIsDisplay = true
        }
        element.slaveIdDisplay = true
        block.hide = false
      } else {
        element.masterIsDisplay = false
        element.slaveIdDisplay = false
        element.isRequire = false
      }
    },
    onMousedown(e, block, element = null) {
      this.dragBlock = block
      this.dragElement = element
      this.dragEnabled = true
      if (this.dragElement) {
        this.dragDiv = this.$refs['drag' + this.dragElement.pagePartElement.elementName][0].$el
        this.dragOffsetX = -(this.blockWidth - 30)
        this.dragOffsetY = -10
      } else {
        this.dragDiv = this.$refs['drag' + this.dragBlock.pagePart.pagePartName][0]
        this.dragDiv.style.height = ''
        this.dragDiv.style.overflow = ''
        this.dragDiv.style.padding = ''
        this.dragOffsetX = -(this.blockWidth - 12)
        this.dragOffsetY = -9
      }
      this.dragDiv.style.position = 'fixed'
      this.dragDiv.style.zIndex = '9999'
      this.dragDiv.style.left = (e.pageX + this.dragOffsetX) + 'px'
      this.dragDiv.style.top = (e.pageY + this.dragOffsetY) + 'px'
    },
    dragging(e) {
      this.dragDiv.style.left = (e.pageX + this.dragOffsetX) + 'px'
      this.dragDiv.style.top = (e.pageY + this.dragOffsetY) + 'px'
    },
    handleDragSort(pageX, pageY) {
      if (this.dragElement) {
        let targetBlock = null
        for (const block of this.upBlocks) {
          const pagePartName = block.pagePart.pagePartName
          const rect = this.$refs[pagePartName][0].getBoundingClientRect()
          if (pageX > rect.left && pageX <= rect.right && pageY >= rect.top && pageY <= rect.bottom) {
            targetBlock = block
            break
          }
        }
        if (!targetBlock) {
          return
        }
        // 从原区域块移除
        this.dragBlock.uiCustomElementList = this.dragBlock.uiCustomElementList.filter(p => p.pagePartElement.elementName !== this.dragElement.pagePartElement.elementName)
        // 关联新区域块的uuid
        this.dragElement[this.elementRelateBlockPropName] = targetBlock.uuid
        if (targetBlock.uiCustomElementList.length > 0) {
          const top = pageY + this.dragOffsetY
          this.dragElement.serialNumber = 0.5
          for (const element of targetBlock.uiCustomElementList) {
            const rect = this.$refs[element.pagePartElement.elementName][0].$el.getBoundingClientRect()
            if (top > rect.top) {
              this.dragElement.serialNumber = element.serialNumber + 0.5
            }
          }
          targetBlock.uiCustomElementList.push(this.dragElement)
          targetBlock.uiCustomElementList.sort((a, b) => a.serialNumber - b.serialNumber)
          let serialNumber = 1
          for (const element of targetBlock.uiCustomElementList) {
            element.serialNumber = serialNumber++
          }
        } else {
          this.dragElement.serialNumber = 1
          targetBlock.uiCustomElementList.push(this.dragElement)
        }
        if (targetBlock.uiCustomElementList.findIndex(p => p.isDisplay) > -1) {
          targetBlock.hide = false
        }
      } else {
        // 无
      }
    },
    onAddedMousedown(e, element) {
      this.dragBlock = null
      this.dragElement = element
      this.dragEnabled = true
      this.dragDiv = this.$refs['addDrag' + this.dragElement.pagePartElement.elementName][0]
      const dragDivRect = this.dragDiv.getBoundingClientRect()
      this.dragOffsetX = -(dragDivRect.width - 17.5)
      this.dragOffsetY = -16
      this.dragDiv.style.position = 'fixed'
      this.dragDiv.style.zIndex = '9999'
      this.dragDiv.style.left = (e.pageX + this.dragOffsetX) + 'px'
      this.dragDiv.style.top = (e.pageY + this.dragOffsetY) + 'px'
    },
    handleAddedDragSort(pageX, pageY) {
      let targetBlock = null
      for (const block of this.upBlocks) {
        const pagePartName = block.pagePart.pagePartName
        const rect = this.$refs[pagePartName][0].getBoundingClientRect()
        if (pageX > rect.left && pageX <= rect.right && pageY >= rect.top && pageY <= rect.bottom) {
          targetBlock = block
          break
        }
      }
      if (!targetBlock) {
        return
      }
      // 从原区域块移除
      const addedElementIndex = this.addedElements.findIndex(p => p.pagePartElement.elementName === this.dragElement.pagePartElement.elementName)
      this.addedElements.splice(addedElementIndex, 1)
      // 关联新区域块的uuid
      this.dragElement[this.elementRelateBlockPropName] = targetBlock.uuid
      if (targetBlock.uiCustomElementList.length > 0) {
        const top = pageY + this.dragOffsetY
        this.dragElement.serialNumber = 0.5
        for (const element of targetBlock.uiCustomElementList) {
          const rect = this.$refs[element.pagePartElement.elementName][0].$el.getBoundingClientRect()
          if (top > rect.top) {
            this.dragElement.serialNumber = element.serialNumber + 0.5
          }
        }
        targetBlock.uiCustomElementList.push(this.dragElement)
        targetBlock.uiCustomElementList.sort((a, b) => a.serialNumber - b.serialNumber)
        let serialNumber = 1
        for (const element of targetBlock.uiCustomElementList) {
          element.serialNumber = serialNumber++
        }
      } else {
        this.dragElement.serialNumber = 1
        targetBlock.uiCustomElementList.push(this.dragElement)
      }
      if (targetBlock.uiCustomElementList.findIndex(p => p.isDisplay) > -1) {
        targetBlock.hide = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  @import './base.scss'
</style>
